// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Servicos_SalvarResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for POST /config/servicos/salvar
 *
 * Returns the created or updated service id under {servico_id}.
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Servicos_SalvarResponseDados {
servico_id?: number
}

export type Servicos_SalvarResponse = ApiResponse<Servicos_SalvarResponseDados>;

registerResponseContract('Servicos_SalvarResponse', {
  servico_id: { type: 'number',  required: false },
})
